function UnauthorizedPage() {
  return <div>Unauthorized page</div>;
}

export default UnauthorizedPage;
